var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"video"},[(_vm.blok.source)?_c('video-embed',{attrs:{"source":_vm.blok.source,"image":_vm.blok.image}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }